import { List, Paper } from "@mui/material";
import React from "react";
import { SystemValueInterface } from "../../Api/System";
import CategoryTitle from "../atoms/CategoryTitle";
import TextSelectFormListItem from "../molecules/TextSelectFormListItem";
import TextFormListItem from "../molecules/TextFormListItem";

interface CouponSystemSettingsProps {
    systemValue?: SystemValueInterface
    onSave?: (key: string, value: string) => void
}

const CouponSystemSettings: React.FC<CouponSystemSettingsProps> = ({
    systemValue,
    onSave
}) => {
    const [couponStudioChargeAtomicityError, setCouponStudioChargeAtomicityError] = React.useState(false)
    const [couponStudioChargeAtomicityHelperText, setCouponStudioChargeAtomicityHelperText] = React.useState("")
    const [couponEquipmentChargeAtomicityError, setCouponEquipmentChargeAtomicityError] = React.useState(false)
    const [couponEquipmentChargeAtomicityHelperText, setCouponEquipmentChargeAtomicityHelperText] = React.useState("")
    const [couponStudioChargeRaitoError, setCouponStudioChargeRaitoError] = React.useState(false)
    const [couponStudioChargeRaitoHelperText, setCouponStudioChargeRaitoHelperText] = React.useState("")
    const [couponEquipmentChargeRaitoError, setCouponEquipmentChargeRaitoError] = React.useState(false)
    const [couponEquipmentChargeRaitoHelperText, setCouponEquipmentChargeRaitoHelperText] = React.useState("")
    const [couponVisitPointError, setCouponVisitPointError] = React.useState(false)
    const [couponVisitPointHelperText, setCouponVisitPointHelperText] = React.useState("")

    return (
        <Paper sx={{margin: "10px"}}>
            <CategoryTitle
                text="ポイントシステム関連設定"
            />
            <List>
                <TextSelectFormListItem
                    text="クーポン支払最小単位(スタジオ代)"
                    initialValue={systemValue?.COUPON_STUDIO_CHARGE_ATOMICITY ? parseInt(systemValue.COUPON_STUDIO_CHARGE_ATOMICITY).toString() : ""}
                    initialValueSelect={systemValue?.COUPON_STUDIO_CHARGE_ATOMICITY ? systemValue.COUPON_STUDIO_CHARGE_ATOMICITY.slice(-1) : ""}
                    selectOptions={[
                        {label: "ポイント", value: "x"},
                        {label: "％（値段の割合）", value: "%"},
                    ]}
                    onValidate={(value, selectValue) => {
                        if (isNaN(Number(value))) {
                            setCouponStudioChargeAtomicityError(true)
                            setCouponStudioChargeAtomicityHelperText("数値を入力してください")
                        } else {
                            setCouponStudioChargeAtomicityError(false)
                            setCouponStudioChargeAtomicityHelperText("")
                        }
                    }}
                    onSave={(value, selectValue) => {
                        if (onSave) {
                            onSave("COUPON_STUDIO_CHARGE_ATOMICITY", value + selectValue)
                        }
                    }}
                    error={couponStudioChargeAtomicityError}
                    helperText={couponStudioChargeAtomicityHelperText}
                />
                <TextSelectFormListItem
                    text="クーポン支払単位(機材レンタル代)"
                    initialValue={systemValue?.COUPON_EQUIPMENT_CHARGE_ATOMICITY ? parseInt(systemValue.COUPON_EQUIPMENT_CHARGE_ATOMICITY).toString() : ""}
                    initialValueSelect={systemValue?.COUPON_EQUIPMENT_CHARGE_ATOMICITY ? systemValue.COUPON_EQUIPMENT_CHARGE_ATOMICITY.slice(-1) : ""}
                    selectOptions={[
                        {label: "ポイント", value: "x"},
                        {label: "％（値段の割合）", value: "%"},
                    ]}
                    onValidate={(value, selectValue) => {
                        if (isNaN(Number(value))) {
                            setCouponEquipmentChargeAtomicityError(true)
                            setCouponEquipmentChargeAtomicityHelperText("数値を入力してください")
                        } else {
                            setCouponEquipmentChargeAtomicityError(false)
                            setCouponEquipmentChargeAtomicityHelperText("")
                        }
                    }}
                    onSave={(value, selectValue) => {
                        if (onSave) {
                            onSave("COUPON_EQUIPMENT_CHARGE_ATOMICITY", value + selectValue)
                        }
                    }}
                    error={couponEquipmentChargeAtomicityError}
                    helperText={couponEquipmentChargeAtomicityHelperText}
                />
                <TextFormListItem
                    text="ポイント付与率(スタジオ代)"
                    endAdornmentText="%"
                    initialValue={systemValue?.COUPON_STUDIO_CHARGE_RAITO ? systemValue.COUPON_STUDIO_CHARGE_RAITO : ""}
                    onValidate={value => {
                        if (isNaN(Number(value))) {
                            setCouponStudioChargeRaitoError(true)
                            setCouponStudioChargeRaitoHelperText("数値を入力してください")
                        } else {
                            setCouponStudioChargeRaitoError(false)
                            setCouponStudioChargeRaitoHelperText("")
                        }
                    }}
                    onSave={(value) => {
                        if (onSave) {
                            onSave("COUPON_STUDIO_CHARGE_RAITO", value)
                        }
                    }}
                    error={couponStudioChargeRaitoError}
                    helperText={couponStudioChargeRaitoHelperText}
                />
                <TextFormListItem
                    text="ポイント付与率(機材レンタル代)"
                    endAdornmentText="%"
                    initialValue={systemValue?.COUPON_EQUIPMENT_CHARGE_RAITO ? systemValue.COUPON_EQUIPMENT_CHARGE_RAITO : ""}
                    onValidate={value => {
                        if (isNaN(Number(value))) {
                            setCouponEquipmentChargeRaitoError(true)
                            setCouponEquipmentChargeRaitoHelperText("数値を入力してください")
                        } else {
                            setCouponEquipmentChargeRaitoError(false)
                            setCouponEquipmentChargeRaitoHelperText("")
                        }
                    }}
                    onSave={(value) => {
                        if (onSave) {
                            onSave("COUPON_EQUIPMENT_CHARGE_RAITO", value)
                        }
                    }}
                    error={couponEquipmentChargeRaitoError}
                    helperText={couponEquipmentChargeRaitoHelperText}
                />
                <TextFormListItem
                    text="来店時付与ポイント数"
                    endAdornmentText="ポイント"
                    initialValue={systemValue?.COUPON_VISIT_POINT ? systemValue.COUPON_VISIT_POINT : ""}
                    onValidate={value => {
                        if (isNaN(Number(value))) {
                            setCouponVisitPointError(true)
                            setCouponVisitPointHelperText("数値を入力してください")
                        } else {
                            setCouponVisitPointError(false)
                            setCouponVisitPointHelperText("")
                        }
                    }}
                    onSave={(value) => {
                        if (onSave) {
                            onSave("COUPON_VISIT_POINT", value)
                        }
                    }}
                    error={couponVisitPointError}
                    helperText={couponVisitPointHelperText}
                />
            </List>
        </Paper>
    );
}

export default CouponSystemSettings